import axios from "axios";
import BASE_URL from "../../assets/global/url";

// Updates a Retained Net Income's name, remarks and selected cutoffs
export const updateRetainedNetIncome = async (payload) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/retained_net_income/updateRetainedNetIncome`,
      payload,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
